<section class="login-container">
  <div class="login-inner-container">

    <div class="login-agilysys-logo">
      <img src="{{logoUrl}}" alt="Agilysys-log">
      @if (showSettingsicon) {
      <i (click)="settings()" class="icon-settings"></i>
      }
    </div>
    <div class="login-action">
      <div class="login-label">{{'login.signin' | translate }}</div>
      <div class="login-body" [ngClass]="loginType == 'Location' ? 'login-location-type' : ''">
        <form action="" class="form-signin" [formGroup]="loginForm" autocomplete="'off'">
          @if (loginType == 'Login') {
          <div class="login-form-action">
            <div class="login-username">
              <mat-label class="agy-mat-label"> <span class="manditory-icon">*</span>{{'login.username'
                | translate}}</mat-label>
              <mat-form-field [disabled]="true" appearance="outline"
                [ngClass]="{'textbox-disabled': loginControlAuth.DisabledUserContainer}">
                <i matPrefix class="icon-user"></i>
                <input type="text" id="username" matInput formControlName="username"
                  placeholder="{{'login.username' | translate}}" #someInput [autofocus]="focusVariable"
                  [autocomplete]="'off'">
              </mat-form-field>
            </div>
            <div class="login-password">
              @if ((commnService.isonlineStatus || (!IsAdUser && !commnService.isonlineStatus))) {
              <mat-label class="agy-mat-label"><span class="manditory-icon">*</span> {{'login.password'
                | translate}}</mat-label>
              }
              @if (!commnService.isonlineStatus && IsAdUser) {
              <mat-label class="agy-mat-label"><span class="manditory-icon">*</span>{{'login.password'
                | translate}}/{{'passcodeconfig.pin' | translate}}</mat-label>
              }
              <mat-form-field [ngClass]="{'textbox-disabled': loginControlAuth.DisabledUserContainer}"
                appearance="outline">
                <i matPrefix class="icon-lock-requisition"></i>
                <input [autocomplete]="'off'" [type]="hidePassword ? 'password' : 'text'" #password matInput
                  id="password" formControlName="password"
                  [placeholder]="(!commnService.isonlineStatus && IsAdUser ? 'login.Password/PIN' : 'login.password') | translate">
                <i matSuffix (click)="togglePassword($event)"
                  [ngClass]="hidePassword ? 'opacity1 icon-hide-password' : 'opacity0 icon-reveal-password'"></i>
              </mat-form-field>
            </div>
            @if( showLoginError ){
            <div class="login-error-content">
              <span (click)="showLoginError = false;" class="icon-remove"></span>
              <span class="product-body-7">{{loginErrorText}}</span>
            </div>
            }
            <!-- @if (!loginControlAuth.HideForgotContainer && commnService.isonlineStatus) {
            <div class="forgot-password">
              <a href="javascript:void(0)" class="forgot-password-text "
                (click)="ForgotPassword()"
                [ngClass]="{'visibility-hidden': loginControlAuth.HideForgotPassword, 'disable-link': false }">{{ 'login.forgotPassword' | translate }}</a>
            </div>
            } -->
          </div>
          }
          @if (loginType == 'Location') {
          <div class="login-instance-location">
            <form [formGroup]="locationFrom" action="">
              <div [ngClass]="isOneSite ? 'disableField' : 'site'">
                <mat-label class="agy-mat-label"> <span class="manditory-icon">*</span>{{'login.site' | translate}}</mat-label>
                <mat-form-field appearance="outline" class="login-site" class="primary-input-outline">
                  <select matNativeControl placeholder="{{'login.site' | translate}}" id="site" formControlName="site">
                    <option selected disabled value style="display:none"></option>
                    @for (site of Sites; track site) {
                    <option [value]="site.Id">
                      {{site.Name}}
                    </option>
                    }
                  </select>
                </mat-form-field>
              </div>
              <div [ngClass]="isOneRole ? 'disableField' : 'location'">
                <mat-label class="agy-mat-label"> <span class="manditory-icon">*</span>{{'login.role' | translate}}</mat-label>
                <mat-form-field appearance="outline" class="primary-input-outline">
                  <select id="instance" matNativeControl placeholder="{{'login.instance' | translate}}"
                    formControlName="instance" focused>
                    <option selected disabled value style="display:none"></option>
                    @for (instance of Roles; track instance) {
                    <option [value]="instance.Id">
                      {{instance.RoleName}}
                    </option>
                    }
                  </select>
                </mat-form-field>
              </div>
              @if( showLoginError ){
              <div class="login-error-content">
                <span (click)="showLoginError = false;" class="icon-remove"></span>
                <span class="product-body-7">{{loginErrorText}}</span>
              </div>
              }
            </form>
          </div>
          }
          <div class="login-actions">
            @if (loginType == 'Login') {
            <button mat-button [disabled]="loginControlAuth.DisabledUserContainer"
              [ngClass]="loginControlAuth.DisabledUserContainer ? 'login-button login-action-Button disabled-bgcolor' : 'large-button-mobile-confirm login-button login-action-Button'"
              (click)="login()">{{'login.signin' | translate }}</button>

            }
            @if (loginType == 'Location') {
            <button mat-button class="large-button-mobile-confirm login-button login-action-Button"
              (click)="loginLocationClick()">{{'common.ok' | translate}}</button>
            }
          </div>
        </form>
        @if (!loginControlAuth.HideAzureContainer && loginType != 'Location') {
        <div class="separation-line">
          <span class="line-break">
            <hr><span class="text-word">{{'common.Signinas' | translate}}</span>
            <hr>
          </span>
        </div>
        }
        @if (!loginControlAuth.HideAzureContainer) {
        <div class="azure-product-login azure-login-btn"
          [ngClass]="{'disableField':!commnService.isonlineStatus, 'full-width-button': loginControlAuth.HideAgilysysAzureContainer}">
          @if (!commnService.IsRguest && IsAdUser && loginType != 'Location') {
          <button mat-button class="azure-login-button large-button-mobile-confirm login-button login-action-Button"
            (click)="adLoginClick()">{{'common.AdLogin' | translate}}</button>
          }
          @if (!commnService.IsRguest && IsAdUser && loginType != 'Location' &&
          !loginControlAuth.HideAgilysysAzureContainer) {
          <button mat-button class="azure-login-button large-button-mobile-confirm login-button login-action-Button"
            (click)="adProductLogin()">{{'common.AdProductLogin' | translate}}</button>
          }
        </div>
        }
        @if (!loginControlAuth.HideAzureContainer) {
        <div class="azure-product-login azure-login-btn-smaller"
          [ngClass]="{'disableField':!commnService.isonlineStatus, 'full-width-button': loginControlAuth.HideAgilysysAzureContainer}">
          @if (!commnService.IsRguest && IsAdUser && loginType != 'Location') {
          <button mat-button class="azure-login-button large-button-mobile-confirm login-button login-action-Button"
            (click)="adLoginClick()">{{'common.AdLoginSmaller' | translate}}</button>
          }
          @if (!commnService.IsRguest && IsAdUser && loginType != 'Location' &&
          !loginControlAuth.HideAgilysysAzureContainer) {
          <button mat-button class="azure-login-button large-button-mobile-confirm login-button login-action-Button"
            (click)="adProductLogin()">{{'common.AdProductLoginSmaller' | translate}}</button>
          }
        </div>
        }
      </div>
    </div>
    <div class="login-footer">
      <div class="agilysys-logo">
        <img src="../../../assets/images/agilysys-logo-new-svg.svg" />
      </div>
      <div class="text-copyright"><span>&#169;</span> {{'common.copyRights' | translate}}{{copyRightYear}}{{'common.agilysysText' | translate}}</div>
    </div>
    <div class="agilysys-union">
      <svg viewBox="0 0 562 488" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M-73.125 322.85C-73.125 202.529 23.8378 105.675 144.317 105.675C264.788 105.675 361.758 202.529 361.758 322.85C361.758 443.177 264.788 540.031 144.317 540.031C26.7791 540.031 -73.125 443.177 -73.125 322.85ZM326.505 117.426C326.505 52.8563 379.398 0.03125 444.042 0.03125C508.687 0.03125 561.58 52.8563 561.58 117.426C561.58 181.988 508.687 234.813 444.042 234.813C379.398 234.813 326.505 181.988 326.505 117.426Z"
          fill="#F7F7F7" />
      </svg>
    </div>
  </div>
</section>

<app-spinner class="loading" name="loading">{{'common.loading' | translate }}...</app-spinner>
<app-toast-message [show]='toastShow' [message]="toastMessage" (ToastDismiss)='toastDismissed($event)'
  [buttonText]="buttonText" (AutoDismiss)='toastAutoDismiss($event)'></app-toast-message>
